// Alertas de itens com DATA (texto 10, A4): fichas das abas, Documentos, Garantias, contas de Finanças,
// Bem-Estar... Usam o MESMO editor da Nova tarefa (components/AlertasEditor) e a mesma lista de AlertaItem:
//  - 'hora': numa hora fixa, `dias` dias antes da data (0 = no dia; negativo = dias depois, ex.: conta vencida);
//  - 'inicio' / 'antes': só quando o item também tem horário (consulta às 14h, aula, check-in...).
// Sem lista guardada vale o jeito de antes (aviso X dias antes e no dia, às 9h): quem nunca mexeu continua igual.
// Os alertas só avisam no celular: não colocam nada no My Planner (são escolhas separadas).
import type { AlertaItem, ModoAviso } from '../store/types';
import { instante } from './fuso';
import { addDays } from './date';
import { t } from './i18n';

/** Hora padrão dos avisos por data (era a única até a 0.72). */
export const HORA_AVISO = '09:00';

/** Os alertas de antes: um por dia da lista (e no dia, se comDia), às 9h. */
export function alertasDosDias(dias: number[] | undefined | null, comDia = true, hora = HORA_AVISO): AlertaItem[] {
  const l = [...new Set([...(dias ?? []), ...(comDia ? [0] : [])])].sort((a, b) => b - a);
  return l.map(n => ({ tipo: 'hora', hora, dias: n }));
}

/** Opções de "quantos dias antes" no editor: as comuns e as que o item já usa. */
export function opcoesDias(extra: number[] = []): number[] {
  return [...new Set([0, 1, 2, 3, 7, 15, 30, ...extra])].sort((a, b) => a - b);
}

/** "No dia", "3 dias antes", "1 dia depois". */
export function rotuloDias(n: number): string {
  if (!n) return t('No dia');
  if (n > 0) return n === 1 ? t('1 dia antes') : t('{n} dias antes', { n });
  return n === -1 ? t('1 dia depois') : t('{n} dias depois', { n: -n });
}

/** Os dias de antes que os alertas usam (para guardar também no formato antigo, ex.: Documento.avisos). */
export const diasDosAlertas = (itens: AlertaItem[]) =>
  [...new Set(itens.filter(a => a.tipo === 'hora' && (a.dias ?? 0) > 0).map(a => a.dias!))].sort((a, b) => b - a);

export type QuandoAlerta = { chave: string; date: Date; dias: number; min: number; inicio: boolean; como?: ModoAviso };

/** Quando cada alerta de um item toca: data (YYYY-MM-DD), horário do item (opcional) e a lista de alertas.
 *  Os "Desligado" ficam de fora. chave: parte única do identificador do aviso. */
export function quandoDosAlertas(data: string, hora: string | null | undefined, itens: AlertaItem[], tz?: string | null): QuandoAlerta[] {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(data)) return [];
  const temHora = !!hora && /^\d{2}:\d{2}$/.test(hora);
  const l: QuandoAlerta[] = [];
  for (const it of itens) {
    if (it.como === 'nada') continue;
    if (it.tipo === 'hora') {
      if (!it.hora || !/^\d{2}:\d{2}$/.test(it.hora)) continue;
      const n = Math.round(it.dias ?? 0);
      l.push({ chave: `h${it.hora}:${n}`, date: instante(addDays(data, -n), it.hora, tz), dias: n, min: 0, inicio: false, como: it.como });
      continue;
    }
    if (!temHora) continue;   // "No início" e "Antes do início" precisam do horário
    const m = it.tipo === 'antes' ? Math.max(0, it.min ?? 0) : 0;
    l.push({ chave: String(m), date: new Date(instante(data, hora!, tz).getTime() - m * 60000), dias: 0, min: m, inicio: true, como: it.como });
  }
  return l;
}
